import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";

var _templateObject;

var _excluded = ["children", "bgColor", "withTransparentHeader", "navItems"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Link from 'next/link';
import styled from 'styled-components';
import { useTranslation } from '@yoweb/next-i18next';
import MainLayout from './MainLayout';
import { Grid } from '@yoweb/ui/components/Grid';
import { Header } from '@yoweb/ui/components/Header';
import { PAGE_INDEX } from '@store/constants/routes';
import { theme } from '@yoweb/ui/styles';
import { YohanaLogo } from '@yoweb/ui/components/Icon/YohanaLogo';
import { Button, ButtonNav } from '@yoweb/ui/components/buttons';
import { getColor, getDuration, getSpace } from '@yoweb/ui/styles/utils/theme';
import { breakpoints, rootFontScalar, media } from '@yoweb/ui/styles/utils';
import { Box } from '@yoweb/ui/components/Box';
import { RenderOn } from '@yoweb/ui/components/RenderOn/RenderOn';
import { Text } from '@yoweb/ui/components/typography';
import { trackEvent } from '@yoweb/utils/analytics/mixpanel';
import { Action } from '@yoweb/types/external-events';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DESKTOP_AVATAR_SIZE_KEY = 'display';
export var MOBILE_AVATAR_SIZE_KEY = 'default';
export var EmployerLayout = function EmployerLayout(_ref) {
  var children = _ref.children,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? 'base000' : _ref$bgColor,
      _ref$withTransparentH = _ref.withTransparentHeader,
      withTransparentHeader = _ref$withTransparentH === void 0 ? true : _ref$withTransparentH,
      navItems = _ref.navItems,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useTranslation = useTranslation(['common']),
      t = _useTranslation.t;

  var DESKTOP_AVATAR_SIZE = theme.iconSizes[DESKTOP_AVATAR_SIZE_KEY];
  var MOBILE_AVATAR_SIZE = theme.iconSizes[MOBILE_AVATAR_SIZE_KEY];

  var handleScrollToSection = function handleScrollToSection(id, ev) {
    ev === null || ev === void 0 ? void 0 : ev.preventDefault();
    var el = document.getElementById(id);

    if (el) {
      trackEvent({
        cta: {
          id: id,
          action: Action.ACTION_LINK_CLICKED
        }
      });
      el.scrollIntoView({
        behavior: 'auto',
        block: 'start'
      });
    }
  };

  return /*#__PURE__*/_jsx(MainLayout, _objectSpread(_objectSpread({}, rest), {}, {
    bgColor: bgColor,
    withTransparentHeader: withTransparentHeader,
    Header: /*#__PURE__*/_jsx(Header, {
      "data-testid": "employer-header",
      showEmptySpace: !withTransparentHeader,
      id: "network-layout-header",
      children: /*#__PURE__*/_jsxs(Grid, {
        flow: "column",
        align: "center",
        justify: "space-between",
        children: [/*#__PURE__*/_jsxs(Box, {
          children: [/*#__PURE__*/_jsx(Link, {
            href: PAGE_INDEX,
            passHref: true,
            legacyBehavior: true,
            children: /*#__PURE__*/_jsxs(LogoAnchor, {
              href: PAGE_INDEX,
              children: [/*#__PURE__*/_jsx(RenderOn.MobileAndTablet, {
                children: /*#__PURE__*/_jsx(YohanaLogo, {
                  width: 71.25,
                  height: MOBILE_AVATAR_SIZE
                })
              }), /*#__PURE__*/_jsx(RenderOn.Desktop, {
                children: /*#__PURE__*/_jsx(YohanaLogo, {
                  width: 95,
                  height: DESKTOP_AVATAR_SIZE
                })
              })]
            })
          }), /*#__PURE__*/_jsx(LogoSubTextContainer, {
            children: /*#__PURE__*/_jsx(Text, {
              size: {
                _: 'sm',
                lg: 'lg'
              },
              children: t('corporate-wellness-logo')
            })
          })]
        }), /*#__PURE__*/_jsxs(Box, {
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          children: [/*#__PURE__*/_jsx(RenderOn.Desktop, {
            children: /*#__PURE__*/_jsx(Box, {
              display: "flex",
              mr: "normal1",
              children: navItems === null || navItems === void 0 ? void 0 : navItems.map(function (navItem) {
                return /*#__PURE__*/_jsx(ButtonNav, {
                  onClick: function onClick(e) {
                    return handleScrollToSection(navItem.sliceId, e);
                  },
                  children: navItem.display
                }, navItem.sliceId);
              })
            })
          }), /*#__PURE__*/_jsx(Button, {
            onClick: function onClick(e) {
              return handleScrollToSection('get-in-touch-section', e);
            },
            variant: "primary",
            "data-testid": "get-a-demo-button",
            children: t('common:header.get-a-demo')
          })]
        })]
      })
    }),
    children: children
  }));
};
var LogoAnchor = styled.a.withConfig({
  componentId: "sc-1waoebf-0"
})(["color:", ";position:relative;z-index:1;display:inline-block;@media (max-width:", "em){position:relative;transition:color ", ";transition-duration:", "ms;transition-delay:", "ms;}"], getColor('base900'), (breakpoints.md - 1) / rootFontScalar, getDuration('interaction'), getDuration('interaction'), getDuration('instant'));
var LogoSubTextContainer = styled.div.withConfig({
  componentId: "sc-1waoebf-1"
})(["display:inline-block;vertical-align:top;margin-top:", ";margin-left:", ";", ""], getSpace('small2'), getSpace('small2'), media.lg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-top: ", ";\n    margin-left: ", ";\n  "])), getSpace('small4'), getSpace('small3')));
export var getEmployerLayout = function getEmployerLayout(page, props) {
  return /*#__PURE__*/_jsx(EmployerLayout, _objectSpread(_objectSpread({}, props), {}, {
    children: page
  }));
};